import React, {PureComponent, Fragment} from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {SUCCESS__16} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';
import {FORM_SUBMIT_SUCCESS_TEXT, EXPLORE_BNB_RENTALS_TEXT, EXPLORE_BNB_RENTALS_TEXT_ARIA, EXPLORE_BNB_RENTALS_LINK} from '../../../utils/constants';

import './GiftCardSubmitSuccess.less';

const FORM_SUBMIT_SUCCESS_LABEL = (
    <FormattedMessage
        id="giftCardSubmitSuccessMessage"
        defaultMessage={FORM_SUBMIT_SUCCESS_TEXT}
    />
);

class GiftCardSubmitSuccess extends PureComponent {
    render() {
        const EXPLORE_BNB_RENTALS_LABEL = this.props.intl.formatMessage({
            id: 'giftCardExploreBedAndBreakfastRentalsMessage',
            defaultMessage: EXPLORE_BNB_RENTALS_TEXT
        });
        return (
            <Fragment>
                <div className="GiftCardSubmitSuccess__Box" id="formSubmitSuccess">
                    <SVGIcon
                        inlineFlex
                        className="text-success"
                        markup={SUCCESS__16}
                    />
                    <span className="GiftCardSubmitSuccess__Message">
                        {FORM_SUBMIT_SUCCESS_LABEL}
                    </span>
                </div>
                <ButtonPrimary label = {EXPLORE_BNB_RENTALS_LABEL} aria-label={this.props.intl.formatMessage({
                    id: 'exploreRentalsTextAria',
                    defaultMessage: EXPLORE_BNB_RENTALS_TEXT_ARIA
                })} className="Button" type="submit" href={EXPLORE_BNB_RENTALS_LINK}
                />
            </Fragment>
        );
    }
}

export default injectIntl(GiftCardSubmitSuccess);
